import React from 'react';
import Table from "../Shared/Table";


function Dtable({children}) {
    return (
       <Table>
            {children}
       </Table>
    )
}

export default Dtable
